const telegramPattern = /^@[a-zA-Z0-9_]{4,}$/;

module.exports = {
    telegramPattern,
}